import { observer } from 'mobx-react'
import React from 'react'

import { PipelinesSelectionPopover } from '@flowwai-frontend/bps-officer-web/common/ui'
import GSResultItem from './GSResultItem'
import { SearchResultType } from '../../../types'

interface Props {
   gsResultItem: SearchResultType
   onClickGSResultItem: (
      pipelineItemId: string,
      pipelineItemName?: string
   ) => void
}

const GSResultItemForTemplateContent = (props: Props): React.ReactElement => {
   const { gsResultItem, onClickGSResultItem } = props

   const { pipelineItemId } = gsResultItem

   const onSelectPipeline = (
      pipelineId: string,
      onSuccessOpen?: () => void
   ): void => {
      onClickGSResultItem(pipelineItemId, pipelineId)
      onSuccessOpen?.()
   }

   return (
      <PipelinesSelectionPopover
         pipelineItemId={pipelineItemId}
         onSelectPipeline={onSelectPipeline}
         popoverStyles={{
            zIndex: 110
         }}
         popoverProps={{
            offset: -340
         }}
      >
         {onClickTrigger => (
            <GSResultItem
               key={gsResultItem.pipelineItemId}
               gsResult={gsResultItem}
               onClickGSResultItem={onClickTrigger}
            />
         )}
      </PipelinesSelectionPopover>
   )
}

export default observer(GSResultItemForTemplateContent)
